import { render, staticRenderFns } from "./AppCustomerRegisteration.vue?vue&type=template&id=a1419962&scoped=true"
import script from "./AppCustomerRegisteration.vue?vue&type=script&lang=js"
export * from "./AppCustomerRegisteration.vue?vue&type=script&lang=js"
import style0 from "./AppCustomerRegisteration.vue?vue&type=style&index=0&id=a1419962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1419962",
  null
  
)

export default component.exports